const BASE_URL = process.env.REACT_APP_API_URL;

export const API_ROUTES = {
  LOGIN: `${BASE_URL}/admin/login`,
  USER_LIST: `${BASE_URL}/admin-user/list`,
  STATIC_DATA: `${BASE_URL}/static`,
  USER_COUNT: `${BASE_URL}/admin-user/counts`,
  USER_DETAIL: `${BASE_URL}/admin-user/`,
  SUSPEND_USER: `${BASE_URL}/admin-user/suspend`,
  RESTORE_USER: `${BASE_URL}/admin-user/restore`,
  UPDATE_USER: `${BASE_URL}/admin-user/`,
  ADMIN_DETAIL: `${BASE_URL}/admin/`,
  REPORT_DETAIL: `${BASE_URL}/report/`,
  REPORT_LIST: `${BASE_URL}/report/list`,
  REPORT_SUSPEND: `${BASE_URL}/report/action`,
  REPORT_COUNT: `${BASE_URL}/report/count`,
  CREATE_TEAM: `${BASE_URL}/admin/create-team`,
  GET_TEAM: `${BASE_URL}/admin/admin-team-list`,
  TRANSACTION_LIST: `${BASE_URL}/admin-user/payments`,
  REFUND_AMOUNT: `${BASE_URL}/admin-user/refund`,
  GET_DASHBOARD_TOTAL_USER: `${BASE_URL}/dashboard/status`,
  GET_RECENT_ACTIVITIES: `${BASE_URL}/dashboard/activities`,
};
